export const procurementEn = {
  orderStatus: {
    DRAFT: 'Draft',
    SENT: 'Sent',
    CONFIRMED: 'Confirmed',
    PARTIALLY_RECEIVED: 'Partially received',
    RECEIVED: 'Fully received',
    BILLED: 'Billed',
    CANCELLED: 'Cancelled',
  },
  receiptStatus: {
    DRAFT: 'Draft',
    POSTED: 'Posted',
    CANCELLED: 'Cancelled',
  },
  qualityStatus: {
    ACCEPTED: 'Accepted',
    DAMAGED_REJECTED: 'Damaged / rejected',
    UNDER_QUARANTINE: 'Under quarantine',
  },
  invoiceStatus: {
    DRAFT: 'Awaiting review',
    MATCHED: 'Matched',
    DISCREPANCY: 'Price discrepancy',
    APPROVED_FOR_PAYMENT: 'Approved for payment',
    PAID: 'Paid',
    CANCELLED: 'Cancelled',
  },
  matchStatus: {
    PERFECT_MATCH: 'Perfect match',
    TOLERANCE_ACCEPTED: 'Within tolerance',
    PRICE_MISMATCH: 'Price mismatch',
    QTY_MISMATCH: 'Quantity mismatch',
    MANUALLY_OVERRIDDEN: 'Manually accepted',
  },
  orders: {
    invalidNumber: 'Enter a valid number; quantity must be greater than 0.',
    invalidTax: 'Enter a tax rate between 0 and 100.',
    title: 'Purchase orders',
    subtitle: 'Create, send and track supplier orders.',
    cardTitle: 'Order overview',
    cardDescription: 'All purchase orders with delivery status and order value.',
    create: 'New purchase order',
    newReceipt: 'Record goods receipt',
    searchPlaceholder: 'Search order number or supplier',
    error: 'Purchase orders could not be loaded.',
    emptyTitle: 'No purchase orders found',
    emptyHint: 'Create a purchase order to start the procurement process.',
    columns: {
      number: 'Order number',
      supplier: 'Supplier',
      orderDate: 'Order date',
      delivery: 'Delivery date',
      status: 'Status',
      total: 'Order value',
      article: 'Article',
      quantity: 'Quantity',
      unit: 'Unit',
      price: 'Purchase price',
      tax: 'VAT %',
      lineNet: 'Net',
      freeText: 'Free text',
    },
    created: 'Purchase order {{number}} has been created.',
    saved: 'Purchase order saved.',
    loadError: 'The purchase order could not be loaded.',
    newTitle: 'New purchase order',
    editorHint: 'Items, terms and delivery address of the purchase order.',
    pdf: 'Download PDF',
    send: 'Send by email',
    confirm: 'Order confirmation received',
    confirmed: 'Purchase order marked as confirmed.',
    cancel: 'Cancel order',
    cancelled: 'Purchase order has been cancelled.',
    cancelTitle: 'Cancel purchase order {{number}}?',
    cancelDescription:
      'The purchase order will be cancelled permanently and can no longer be edited afterwards.',
    cancelReason: 'Cancellation reason',
    receiveGoods: 'Record goods receipt',
    itemsTitle: 'Items',
    itemsHint: 'Supplier articles with tier prices or free text items.',
    articlePlaceholder: 'Search article',
    noSupplierProducts: 'No articles are assigned to this supplier.',
    freeTextPlaceholder: 'Item description',
    removeItem: 'Remove item',
    addItem: 'Add item',
    net: 'Net',
    tax: 'VAT',
    gross: 'Gross',
    headerTitle: 'Order header',
    headerHint: 'Supplier, dates and terms.',
    supplier: 'Supplier',
    supplierPlaceholder: 'Search supplier',
    noSuppliers: 'No suppliers found.',
    minimumOrderValue: 'Minimum order value',
    deliveryTime: 'Lead time',
    days: '{{count}} days',
    expectedDelivery: 'Expected delivery date',
    paymentTerms: 'Payment terms (days)',
    incoterms: 'Incoterms',
    storageArea: 'Target storage area',
    storageAreaHint: 'Pre-filled when recording the goods receipt.',
    notes: 'Notes',
    email: {
      title: 'Send purchase order',
      description: 'The order is attached as PDF and the status is set to "Sent".',
      to: 'Recipient',
      subject: 'Subject',
      body: 'Message',
      submit: 'Send',
      sent: 'Purchase order has been sent.',
      defaultSubject: 'Purchase order {{number}}',
      defaultBody: 'Hello,\n\nplease find attached our purchase order {{number}}.\n\nKind regards',
    },
  },
  receipts: {
    warehouseRequired: 'Select the warehouse for this bin. A label alone does not identify stock.',
    title: 'Goods receipts',
    subtitle: 'Overview of posted and open goods receipts.',
    cardTitle: 'Goods receipt overview',
    cardDescription: 'All recorded deliveries with their purchase order reference.',
    create: 'Record goods receipt',
    searchPlaceholder: 'Receipt, order or delivery note number',
    error: 'Goods receipts could not be loaded.',
    listEmptyTitle: 'No goods receipts yet',
    listEmptyHint: 'Record a delivery to update your stock.',
    columns: {
      number: 'Receipt number',
      supplier: 'Supplier',
      order: 'Purchase order',
      deliveryNote: 'Delivery note',
      date: 'Received on',
      status: 'Status',
    },
    terminalTitle: 'Record goods receipt',
    terminalSubtitle: 'Scan the order, verify quantities and post stock bindingly.',
    selectOrder: 'Select purchase order',
    selectOrderHint: 'Scan the order number or pick one of the open purchase orders.',
    scanOrder: 'Scan order number',
    scanPlaceholder: 'e.g. EK-2026-0001',
    openOrders: 'Open purchase orders',
    openOrdersPlaceholder: 'Select order',
    emptyTitle: 'No purchase order selected',
    emptyHint: 'Scan the delivery note barcode or select a purchase order.',
    loadError: 'The order items could not be loaded.',
    positionsTitle: 'Items of {{number}}',
    nothingOpen: 'This purchase order has no open quantities.',
    batchManaged: 'Batch managed',
    open: 'Open: {{quantity}} {{unit}}',
    quantityReceived: 'Received quantity',
    quantityInvalid: 'Please enter a quantity greater than 0.',
    batchNumber: 'Batch number',
    batchRequired: 'A batch number is mandatory for batch managed articles.',
    expiryDate: 'Best before date',
    expiryRequired: 'Please enter a best before date.',
    storageLocation: 'Storage bin / shelf',
    storageLocationPlaceholder: 'e.g. A-03-12',
    quality: 'Quality',
    deliveryNoteTitle: 'Delivery note',
    deliveryNoteHint: 'Record the delivery note number and attach a scan or photo.',
    deliveryNoteNumber: 'Delivery note number',
    storageArea: 'Storage area',
    notes: 'Notes',
    attachScan: 'Scan or upload delivery note',
    noScan: 'No document attached',
    blocked: '{{count}} item(s) are still incomplete.',
    ready: '{{count}} item(s) will be posted.',
    submit: 'Post goods receipt & update stock',
    posted: 'Goods receipt {{number}} was posted and stock was updated.',
  },
  invoices: {
    title: 'Vendor invoices',
    subtitle: 'Monitor creditors by due date and cash discount deadline.',
    cardTitle: 'Incoming invoices',
    cardDescription: 'All supplier invoices with review and payment status.',
    create: 'Record invoice',
    createTitle: 'Record vendor invoice',
    createDescription: 'Record the invoice for a purchase order and attach the document.',
    created: 'Invoice {{number}} has been recorded.',
    searchPlaceholder: 'Search invoice number or supplier',
    error: 'Vendor invoices could not be loaded.',
    emptyTitle: 'No vendor invoices found',
    emptyHint: 'Record a supplier invoice to start the review.',
    blocked: 'Payment blocked',
    order: 'Purchase order',
    orderPlaceholder: 'Select order',
    number: 'Invoice number',
    invoiceDate: 'Invoice date',
    discountPercent: 'Cash discount %',
    discountDays: 'Discount days',
    document: 'Invoice document (PDF or scan)',
    addItem: 'Add item',
    removeItem: 'Remove item',
    submit: 'Record invoice',
    discountHint: 'Cash discount {{percent}} % available for {{count}} more days',
    discountHint_one: 'Cash discount {{percent}} % available today only',
    discountGone: 'Discount period expired',
    kpi: {
      open: 'Open amount',
      overdue: 'Overdue',
      discrepancy: 'With discrepancy',
      discount: 'Discount expiring',
    },
    columns: {
      number: 'Invoice number',
      supplier: 'Supplier',
      invoiceDate: 'Invoice date',
      dueDate: 'Due on',
      discount: 'Cash discount',
      status: 'Status',
      gross: 'Gross',
      description: 'Description',
      quantity: 'Quantity',
      unitPrice: 'Unit price',
      taxRate: 'VAT %',
    },
  },
  match: {
    title: 'Three-way match {{number}}',
    loadError: 'The invoice match could not be loaded.',
    run: 'Recalculate match',
    clear: 'All items match.',
    discrepancies: '{{count}} item(s) deviate.',
    documentTitle: 'Supplier invoice',
    documentError: 'The document could not be loaded.',
    noDocument: 'No document attached',
    noDocumentHint: 'Upload the invoice as PDF or scan to review it here.',
    upload: 'Upload document',
    uploaded: 'Document has been stored.',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    rotate: 'Rotate',
    reload: 'Reload',
    tableTitle: 'Order / delivery / invoice',
    counts: '{{matched}} exact · {{tolerance}} within tolerance · {{discrepancy}} deviating',
    columns: {
      position: 'Item',
      description: 'Description',
      ordered: 'Ordered',
      delivered: 'Delivered',
      invoiced: 'Invoiced',
      variance: 'Variance',
      status: 'Status',
    },
    totalVariance: 'Total variance',
    approve: 'Approve for payment',
    approved: 'Invoice has been approved for payment.',
    acceptTolerance: 'Accept tolerance manually',
    override: {
      title: 'Accept variance manually',
      description: 'The reason is stored in the match log and the audit trail.',
      reason: 'Reason',
      submit: 'Accept variance',
      saved: 'Variance has been accepted.',
    },
    complaint: {
      action: 'Send complaint',
      title: 'Complaint to supplier',
      description: 'The message is sent by email and logged.',
      to: 'Email address',
      subject: 'Subject',
      body: 'Message',
      submit: 'Send complaint',
      sent: 'Complaint has been sent.',
      defaultSubject: 'Query regarding invoice {{number}}',
      defaultBody:
        'Hello,\n\nwhile reviewing your invoice {{number}} we found a variance of {{variance}} compared to the purchase order and the goods receipt.\n\nPlease review the case and send us a corrected invoice.\n\nKind regards',
    },
  },
} as const;
